
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogHeader, 
  DialogTitle, 
  DialogTrigger 
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { UserIcon } from "lucide-react";

type RegisterModalProps = {
  children: React.ReactNode;
}

const RegisterModal = ({ children }: RegisterModalProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  
  const handleNavigate = (path: string) => {
    setOpen(false);
    navigate(path);
  };
  
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Escolha como deseja se cadastrar</DialogTitle>
          <DialogDescription>
            Selecione o tipo de conta que deseja criar na plataforma PsiOnline.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
          <Button 
            variant="outline" 
            className="flex flex-col h-auto py-6 gap-2"
            onClick={() => handleNavigate('/register')}
          >
            <UserIcon className="h-10 w-10 text-primary" />
            <div className="text-center">
              <div className="font-medium">Sou Paciente</div>
              <div className="text-sm text-muted-foreground">Quero marcar consultas</div>
            </div>
          </Button>
          
          <Button 
            variant="outline" 
            className="flex flex-col h-auto py-6 gap-2"
            onClick={() => handleNavigate('/psychologist-register')}
          >
            <UserIcon className="h-10 w-10 text-tertiary" />
            <div className="text-center">
              <div className="font-medium">Sou Psicólogo</div>
              <div className="text-sm text-muted-foreground">Quero oferecer consultas</div>
            </div>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RegisterModal;
